<h2>Theme Styles</h2>

<!-- Shadows Section -->
<section class="theme-section">
	<h3>Shadows</h3>
	<div class="shadows-grid">
		@for (shadow of shadows; track shadow.variable) {
			<div class="shadow-item">
				<div class="shadow-box" [style.box-shadow]="'var(' + shadow.variable + ')'">
					<span class="shadow-name">{{ shadow.name }}</span>
				</div>
				<div class="shadow-info">
					<code>{{ shadow.variable }}</code>
				</div>
			</div>
		}
	</div>

	<div class="code-block">
		<h4>CSS Variables</h4>
		<pre><code>:root &#123;
  --shadow-card: 0px 40px 40px rgba(35, 35, 35, 0.05);
  --shadow-input: 0px 0px 6px rgba(108, 117, 125, 0.2);
  --shadow-elemnts: 0px 0px 40px rgba(0, 0, 0, 0.05);
  --shadow-dropdown: 0px 10px 6px 0px rgba(108, 117, 125, 0.15);
&#125;</code></pre>
	</div>
</section>

<!-- Colors Section -->
<section class="theme-section">
	<h3>Color Palette (Light Theme)</h3>

	@for (category of categories; track category) {
		<div class="color-category">
			<h4>{{ category }}</h4>
			<table class="color-table">
				<thead>
					<tr>
						<th>Preview</th>
						<th>Name</th>
						<th>Variable</th>
						<th>Value</th>
					</tr>
				</thead>
				<tbody>
					@for (color of getColorsByCategory(category); track color.variable) {
						<tr>
							<td>
								<div class="color-preview" [style.background-color]="'var(' + color.variable + ')'"></div>
							</td>
							<td>{{ color.name }}</td>
							<td>
								<div class="variable-cell">
									<code>{{ color.variable }}</code>
									<button type="button"
										class="copy-button"
										(click)="copyToClipboard(color.variable)"
										title="Copy variable"
									>
										<svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
											<path d="M3.33333 10H2.66667C2.31304 10 1.97391 9.85952 1.72386 9.60947C1.47381 9.35943 1.33333 9.02029 1.33333 8.66667V2.66667C1.33333 2.31304 1.47381 1.97391 1.72386 1.72386C1.97391 1.47381 2.31304 1.33333 2.66667 1.33333H8.66667C9.02029 1.33333 9.35943 1.47381 9.60947 1.72386C9.85952 1.97391 10 2.31304 10 2.66667V3.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
									</button>
								</div>
							</td>
							<td><code>{{ color.value }}</code></td>
						</tr>
					}
				</tbody>
			</table>
		</div>
	}
</section>

